<section class="navigation">
  <!-- Title -->
  <div class="d-flex justify-content-between align-items-center mb-2">
    <h3
      class="text-main font-weight--400"
    >
      Kies een navigatie-app:
    </h3>
    <button mat-icon-button (click)="sheet.dismiss('closed-by-user')">
      <mat-icon fontSet="material-symbols-outlined">close</mat-icon>
    </button>
  </div>
  <!-- End title -->

  <div class="d-flex justify-content-around align-items-center">
    @if (platform.IOS) {
      <a
        target="_blank"
        rel="noopener noreferrer"
        href="http://maps.apple.com/maps?q={{data.lat}},{{data.lng}}"
      >
        <img alt="Navigate with Apple Maps" class="navigator-icon" src="/navigators/maps.png">
      </a>
    }
    <a
      target="_blank"
      rel="noopener noreferrer"
      href="https://www.google.com/maps/dir/?api=1&destination={{data.lat}},{{data.lng}}&travelmode=walking&dir_action=navigate">
      <img alt="Navigate with Google Maps" class="navigator-icon" src="/navigators/google-maps.png">
    </a>

    <a
      target="_blank"
      rel="noopener noreferrer"
      href="https://www.waze.com/ul?ll={{data.lat}}%2C{{data.lng}}&navigate=yes&zoom=17">
      <img alt="Navigate with Waze" class="navigator-icon" src="/navigators/waze.png">
    </a>
  </div>
</section>
